export default "__VITE_ASSET__Dm4Q9qQE__"